import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FieldWrapper,
  Input,
  Label,
} from '@commenda/kakashi';
import { useEffect, useState } from 'react';

interface ISaveViewDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  /** Name of the view being edited; omitted when creating a new one. */
  existingName?: string;
}

const MAX_NAME_LENGTH = 100;

export const SaveViewDialog = ({
  open,
  onClose,
  onSave,
  existingName,
}: ISaveViewDialogProps) => {
  const [name, setName] = useState('');
  const trimmed = name.trim();
  const isEditMode = existingName !== undefined;

  useEffect(() => {
    if (open) setName(existingName ?? '');
  }, [open, existingName]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!trimmed) return;
    onSave(trimmed);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader className="flex flex-col items-start">
          <DialogTitle>{isEditMode ? 'Edit view' : 'Save view'}</DialogTitle>
          <DialogDescription className="mt-md">
            {isEditMode
              ? 'Update the name and apply the current layout to this view.'
              : 'Save the current layout and filters as a reusable view.'}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="px-2xl pb-2xl">
            <FieldWrapper>
              <Label htmlFor="report-view-name">View name</Label>
              <Input
                id="report-view-name"
                autoFocus
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter a name for this view"
                maxLength={MAX_NAME_LENGTH}
              />
            </FieldWrapper>
          </div>
          <DialogFooter>
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={!trimmed}>
              {isEditMode ? 'Update view' : 'Save view'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
